import { get } from "lodash";
import * as constants from "../../constants";

const initialState = {
  isLoading: false,
  isError: false,
  errors: [],
  customFields: {
    totalElements: 0,
    results: [],
  },
  isDeleteSuccess: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case constants.FETCH_SETTINGS_CUSTOM_FIELDS_SUCCESS: {
      const customFields = get(action, "payload", {});
      return {
        ...state,
        customFields: {
          totalElements: customFields.length,
          results: customFields,
        },
        errors: [],
        isError: false,
        isLoading: false,
      };
    }
    case constants.FETCH_SETTINGS_CUSTOM_FIELDS_ERROR: {
      return {
        ...state,
        customFields: {
          totalElements: 0,
          results: [],
        },
        errors: action.payload,
        isError: true,
        isLoading: false,
      };
    }
    case constants.CUSTOM_FIELDS_DELETE_SUCCESS: {
      return {
        ...state,
        errors: action.payload,
        isDeleteSuccess: true,
        isError: true,
        isLoading: false,
      };
    }
    case constants.CUSTOM_FIELDS_DELETE_ERROR: {
      return {
        ...state,
        errors: action.payload,
        isDeleteSuccess: false,
        isError: true,
        isLoading: false,
      };
    }
    default:
      return state;
  }
}

export const getIsLoading = (state) => get(state, "customFields.isLoading");

export const getCustomFieldsList = (state) =>
  get(state, "customFields.customFields.results");
export const getCustomFieldsListTotalElements = (state) =>
  get(state, "customFields.customFields.totalElements");

  export const getIsDeleteSuccess = (state) => get(state, "customFields.isDeleteSuccess");

export const getIsError = (state) => get(state, "customFields.isError");

export const getErrors = (state) => get(state, "customFields.errors");
